import { render, staticRenderFns } from "./OrderShowFiles.vue?vue&type=template&id=d4d43a32&"
import script from "./OrderShowFiles.vue?vue&type=script&lang=js&"
export * from "./OrderShowFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports